import { all, take, put, race, select, takeLatest } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'

import { openDialog } from '../../services/dialog/actions'
import { CONFIRM_DIALOG_ON_BUTTON_CLICK } from '../Dialog/components/Confirm/constants'

import { groupStackSelector } from '../../scenes/Gnosus/components/GroupStack/selectors'
import { setupGroupStack } from '../../scenes/Gnosus/components/GroupStack/actions'
import { deleteGroupRequest, deleteGroupFromEntityStack } from './actions'

import { DELETE_GROUP, DELETE_GROUP_REQUEST } from './constants'

function* deleteGroupRequestSaga(_action) {
    const {
        data: { groupId },
    } = _action
    const { activeGroup } = yield select(groupStackSelector)

    const dialogSettings = {
        header: { textId: 'deleteGroup', icon: 'warning' },
        question: {
            textId: 'deleteGroup',
        },
        buttons: ['yes', 'no'],
    }

    const userResponse = yield all({
        answer: race({
            delete: take(CONFIRM_DIALOG_ON_BUTTON_CLICK('yes', groupId)),
            cancel: take(CONFIRM_DIALOG_ON_BUTTON_CLICK('no', groupId)),
        }),
        dialog: put(openDialog('confirm', groupId, dialogSettings)),
    })

    if (userResponse.answer.delete) {
        const result = yield all({
            response: race({
                success: take(`${DELETE_GROUP_REQUEST}_${SUCCESS}`),
                failed: take(`${DELETE_GROUP_REQUEST}_${FAILED}`),
            }),
            request: put(deleteGroupRequest(groupId)),
        })

        if (!result.response.failed) {
            yield put(deleteGroupFromEntityStack(groupId))

            if (activeGroup === groupId) {
                yield put(setupGroupStack(null))
            }
        }
        // TODO: Error handling
    }

    return null
}

export default function* groupSaga() {
    yield all([takeLatest(DELETE_GROUP, deleteGroupRequestSaga)])
}
